import { Box, Button, ButtonAppearance, ButtonSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { MessageType } from '../types';

interface MessageTypeProps {
  messageType?: MessageType;
}

export const ModalFooterStyled = styled(Box).attrs({
  justifyContent: { sm: 'flex-end' },
})`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
`;

export const BorderStyled = styled(Box).attrs({
  mx: { sm: '500' },
})`
  border-bottom: dashed 2px ${({ theme }) => theme.colors.grey[300]};
`;

export const MessageTypeStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  m: { sm: '300' },
})<MessageTypeProps>`
  width: ${({ theme }) => theme.spacings[700]};
  height: ${({ theme }) => theme.spacings[700]};
  border-radius: ${({ theme }) => theme.radii[100]};

  ${({ theme, messageType }) =>
    css`
      background-color: ${messageType === MessageType.ERROR ? theme.colors.red[500] : theme.colors.orange[500]};
      border: solid 1px ${messageType === MessageType.ERROR ? theme.colors.red[200] : theme.colors.orange[200]};
    `};
`;

export const FooterButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.PRIMARY,
  size: ButtonSize.SMALL,
})<MessageTypeProps>`
  ${({ theme }) => css`
    min-width: 96px;
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.white};
    padding: ${theme.spacings[500]};
  `}
  ${({ theme, messageType }) =>
    css`
      background-color: ${messageType === MessageType.ERROR ? theme.colors.red[700] : theme.colors.orange[700]};
      &:hover {
        background-color: ${messageType === MessageType.ERROR ? theme.colors.red[700] : theme.colors.orange[700]};
      }
    `};
`;
